
import useFetchZone from "./plugins/useFetchZone.js";
import useSandbox, { useWindowInjection } from "./plugins/useSandBox.js";
import useCustomComponent from "./plugins/useCustomComponent.js";
import useSharing from "./plugins/useSharing.js";
import { ZONE_JUST_GET_HOOK } from "./enum/ENUM.js";
import ReactiveZone from "./ReactiveZoneClass.js";
import useDiscard from "./useDiscard.js";
import useDefineComponent from "./plugins/useDefineComponent.js";
import ReactiveZoneGlobal from "./ReactiveZoneGlobal.js";
import useMap from "./utils/useMap.js";

const zoneCaching = useMap();

const [setTracking] = (() => {
    const caching = useMap();
    const setTracking = (tracking, zone) => {
        caching.set(tracking, zone);
    }

    const doGarbage = () => {
        console.log("doGarbage")
        const arr = Array.from(caching.keys());
        for (let i in arr) {
            const o = arr[i];
            /** @type {ReactiveZone} */
            const zone = caching.get(o);
            if (zone.canCollectGarbage()) {
                zone.discardZone();
                caching.delete(o);
                zoneCaching.delete(o);
            }
        }
    }

    // setInterval(doGarbage, 5000)

    return [setTracking]
})();


const { injectWindow, extractPrevent } = useWindowInjection();

const { defineComponent } = useCustomComponent();

const _exportHooks = {
    "useFetchZone": useFetchZone,
    "useSandbox": useSandbox,
    "injectWindow": injectWindow,
    "extractPrevent": extractPrevent,
    "useWindowInjection": useWindowInjection,
    "useDefineComponent": defineComponent,
    "useSharing": useSharing
}

/**
 * @type {useReactiveZone} 
 * */
export const useReactiveZone = (trackingObject = Symbol("tracking")) => {
    if (trackingObject === ZONE_JUST_GET_HOOK) {
        return _exportHooks;
    }
    if (zoneCaching.has(trackingObject)) {
        return zoneCaching.get(trackingObject);
    } else {
        const newZone = new ReactiveZone(trackingObject);
        const {
            discardZone,
            useTemplate,
            injectPropToZone,
            onZoneChanges,
            onZoneReady,
            onZoneInit,
            onZoneDestroy,
            injectMethodToZone,
            refreshProp,
            useElementRef,
            useZoneTransform,
            useZoneComputed,
            useElementRefList
        } = newZone


        const exportInstance = {
            "useTemplate": useTemplate.bind(newZone),
            "discardZone": discardZone.bind(newZone),
            "useTemplate": useTemplate.bind(newZone),
            "injectPropToZone": injectPropToZone.bind(newZone),
            "onZoneChanges": onZoneChanges.bind(newZone),
            "onZoneReady": onZoneReady.bind(newZone),
            "onZoneInit": onZoneInit.bind(newZone),
            "onZoneDestroy": onZoneDestroy.bind(newZone),
            "injectMethodToZone": injectMethodToZone.bind(newZone),
            "refreshProp": refreshProp.bind(newZone),
            "useElementRef": useElementRef,
            "useElementRefList": useElementRefList,
            "useZoneTransform": useZoneTransform,
            "useZoneComputed": useZoneComputed,
            "useDefineComponent": useDefineComponent,
            ..._exportHooks
        }

        zoneCaching.set(trackingObject, exportInstance);
        newZone.onZoneDestroy(() => {
            zoneCaching.delete(trackingObject);
        })
        return exportInstance;
    }
}

(function (window) {
    window['useReactiveZone'] = useReactiveZone;
    window['ReactiveZone'] = ReactiveZoneGlobal
})(window);
